import React from "react";
import { Route, Switch } from "react-router-dom";

// Async Component
import asyncComponent from "../components/asyncComponent/AsyncComponent";
import { APP_BROWSER_ROUTES, APP_ROUTES } from "../constants/AppGlobal";
// Layouts
import _DefaultLayout from "../layouts/DefaultLayout";
import Invoice from "../pages/invoice/Invoice";
import NewPassword from "../pages/newPassword/NewPassword";

// DefaultLayout is untyped (legacy class component wrapped in withRouter + connect);
const DefaultLayout = _DefaultLayout as React.ComponentType<
	React.PropsWithChildren<{ pageName?: string; hasHeader?: boolean }>
>;

// Pages
const AsyncHomePage = asyncComponent(() => import("../pages/home/HomePage"));
const AsyncPlansPage = asyncComponent(() => import("../pages/plans/PlansPageVariation"));

const AsyncCheckoutPage = asyncComponent(() => import("../pages/checkout/CheckoutPage"));
const AsyncRCELandingPage = asyncComponent(() => import("../pages/RCELandingPage"));
const AsyncInvitePage = asyncComponent(() => import("../pages/InvitePage"));
const AsyncSignInPage = asyncComponent(() => import("../pages/sign-in/SignInPage"));
const AsyncNewSignUpPage = asyncComponent(() =>
	import("../pages/sign-in/NewSignUpPage").then(mod => ({ default: mod.NewSignUpPage }))
);

const AsyncAnkabutSignupPage = asyncComponent(() =>
	import("../pages/sign-in/AnkabutSignupPage").then(mod => ({ default: mod.AnkabutSignupPage }))
);

const AsyncStudentSignUpPage = asyncComponent(() => import("../pages/sign-in/StudentSignUpPage"));
const AsyncTemplateRedirect = asyncComponent(() => import("../pages/TemplateRedirect"));
const AsyncExpiredAccount = asyncComponent(() => import("../pages/ExpiredAccount"));
const AsyncNoEcommerce = asyncComponent(() => import("../pages/NoEcommerce"));
const AsyncSegmentationInfoRedirect = asyncComponent(
	() => import("../pages/SegmentationInfoRedirect")
);
const AsyncInvalidEmail = asyncComponent(() => import("../components/segment/InvalidEmail"));

type LayoutRoute = {
	path: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	page: React.ComponentType<any>;
	pageName: string;
	hasHeader?: boolean;
};

const layoutRoutes: LayoutRoute[] = [
	{
		path: APP_ROUTES.PLANS_SIGN_UP,
		page: AsyncPlansPage,
		pageName: "Pricing Page",
		hasHeader: false,
	},
	{ path: APP_ROUTES.PLANS_PAGE, page: AsyncPlansPage, pageName: "Plans Page", hasHeader: false },
	{ path: APP_ROUTES.HOMEPAGE, page: AsyncHomePage, pageName: "Home Page" },
	{
		path: APP_BROWSER_ROUTES.INVALID_EMAIL_PAGE,
		page: AsyncInvalidEmail,
		pageName: "Invalid Email Page",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.PLANS_PAGE_BROWSER,
		page: AsyncPlansPage,
		pageName: "Plans Page",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.CHECKOUT_SUMMARY_PAGE,
		page: AsyncCheckoutPage,
		pageName: "Checkout Page",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.RCE_LANDING,
		page: AsyncRCELandingPage,
		pageName: "RCE Login",
		hasHeader: false,
	},
	{
		path: APP_ROUTES.INVITE_PAGE,
		page: AsyncInvitePage,
		pageName: "Invitation page",
		hasHeader: false,
	},
	{
		path: APP_ROUTES.INVITE_PAGE_SLASH,
		page: AsyncInvitePage,
		pageName: "Invitation page",
		hasHeader: false,
	},
	{ path: APP_ROUTES.LOGIN_PAGE, page: AsyncSignInPage, pageName: "Login page", hasHeader: false },
	{
		path: APP_ROUTES.NEW_PASSWORD,
		page: NewPassword,
		pageName: "New password page",
		hasHeader: false,
	},
	{
		path: APP_ROUTES.SIGN_UP_PAGE,
		page: AsyncNewSignUpPage,
		pageName: "Sign up page",
		hasHeader: false,
	},
	{
		path: APP_ROUTES.ANKABUT_SIGN_UP,
		page: AsyncAnkabutSignupPage,
		pageName: "Ankabut sign up page",
		hasHeader: false,
	},
	{
		path: APP_ROUTES.K12_STUDENT_SIGN_UP,
		page: AsyncStudentSignUpPage,
		pageName: "Student sign up page",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.TEMPLATE_REDIRECT,
		page: AsyncTemplateRedirect,
		pageName: "Template Redirect Page",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.EXPIRED_ACCOUNT,
		page: AsyncExpiredAccount,
		pageName: "Expired account",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.NO_ECOMMERCE,
		page: AsyncNoEcommerce,
		pageName: "No E-commerce",
		hasHeader: false,
	},
	{
		path: APP_BROWSER_ROUTES.SEGMENTATION_INFO_REDIRECT,
		page: AsyncSegmentationInfoRedirect,
		pageName: "Segmentation Info Redirect Page",
		hasHeader: false,
	},
	{
		path: APP_ROUTES.INVOICE_PAYMENT_PAGE,
		page: Invoice,
		pageName: "Invoice payment page",
		hasHeader: false,
	},
];

const appRoutesBrowser = ({ childProps }) => {
	return (
		<Switch>
			{layoutRoutes.map(({ path, page: Page, pageName, hasHeader }) => (
				<Route
					key={path}
					path={path}
					exact
					render={props => (
						<DefaultLayout pageName={pageName} hasHeader={hasHeader}>
							<Page {...props} {...childProps} />
						</DefaultLayout>
					)}
				/>
			))}
		</Switch>
	);
};

export default appRoutesBrowser;
